jQuery(async function ($) {
  function updateLinksWithQueryParams(links: NodeListOf<Element>) {
    const currentUrl = new URL(window.location.href);
    const currentParams = currentUrl.searchParams;
    links.forEach(function (link: any) {
      let originalHref = link.dataset.originalHref || link.getAttribute("href");
      if (!link.dataset.originalHref) {
        link.dataset.originalHref = originalHref;
      }

      if (originalHref && currentParams.toString()) {
        const separator = originalHref.includes("?") ? "&" : "?";
        link.setAttribute(
          "href",
          originalHref + separator + currentParams.toString()
        );
      } else {
        link.setAttribute("href", originalHref);
      }
    });
  }

  try {
    const transferParamsLink = document.querySelectorAll("[transfer-params]");
    if (transferParamsLink.length > 0) {
      updateLinksWithQueryParams(transferParamsLink);
      (window as any).navigation.addEventListener("navigate", () => {
        updateLinksWithQueryParams(transferParamsLink);
      });
    }
  } catch (error) {
    console.error("Error in common website functionality : ", error);
  }
});
